import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import API_URL from "../Config";
import AssetBackdrop from "./AssetBackdrop";
import MigArchCredit from "./MigArchCredit";
import "./Login.css";

const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    const value = email.trim();
    if (!EMAIL_PATTERN.test(value)) {
      setError("Please enter a valid email address.");
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      const { data } = await axios.post(`${API_URL}/api/password/forgot`, { email: value });
      setSent(data.message);
    } catch (err) {
      setError(err.response?.data?.message || "Could not send the link. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <AssetBackdrop />
      <div className="login-box">
        <div className="text-center">
          <div className="icon-wrapper">
            <img src="/logo-jumig-store.png" alt="JUMIG Store" />
          </div>
          <p className="login-kicker">Archive Portal</p>
          <h1 className="title">Forgot password</h1>
          <p className="subtitle">Enter the email you signed up with and we will send you a link to choose a new password.</p>
        </div>

        {sent ? (
          <>
            <p className="login-message" role="status">
              {sent} Check your spam folder if it does not arrive in a few minutes.
            </p>
            <button type="button" className="login-button" onClick={() => setSent("")}>
              Send again
            </button>
          </>
        ) : (
          <form onSubmit={submit} noValidate>
            {error && (
              <p className="login-message is-error" role="alert">
                {error}
              </p>
            )}
            <div className="input-group">
              <input
                type="email"
                placeholder="Email address"
                aria-label="Email address"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="email"
                autoFocus
                required
              />
            </div>
            <button type="submit" className="login-button" disabled={submitting}>
              {submitting ? "Sending..." : "Send reset link"}
            </button>
          </form>
        )}

        <div className="login-register">
          Remembered it? <Link to="/login">Back to sign in</Link>
        </div>
        <MigArchCredit className="login-credit" />
      </div>
    </div>
  );
}
